export default __webpack_public_path__ + "static/Luciana 04_SMALL-e9a4d648353f0604ad32eb40cfc140dc.png";